function cov_1w6ke55j5p() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Garage.tsx";
  var hash = "ee1e57ec71b1bb73fd419af948da8b6707038ca6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Garage.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ee1e57ec71b1bb73fd419af948da8b6707038ca6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1w6ke55j5p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1w6ke55j5p();
var Icon = (cov_1w6ke55j5p().s[0]++, {
  name: 'garage',
  svg: "<path d=\"M19 14.75C19 15.4404 18.4404 16 17.75 16C17.0596 16 16.5 15.4404 16.5 14.75C16.5 14.0596 17.0596 13.5 17.75 13.5C18.4404 13.5 19 14.0596 19 14.75Z\" fill=\"currentColor\"/>\n  <path d=\"M10 13.5C9.30964 13.5 8.75 14.0596 8.75 14.75C8.75 15.4404 9.30964 16 10 16H14C14.6904 16 15.25 15.4404 15.25 14.75C15.25 14.0596 14.6904 13.5 14 13.5H10Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.39761 7.00455L5.30934 7.5H3.25C2.55964 7.5 2 8.05964 2 8.75C2 9.44036 2.55964 10 3.25 10H4.86394L4.81953 10.2492C3.15058 11.0593 2 12.7703 2 14.75C2 15.7202 2.27632 16.6258 2.75456 17.3925C2.75154 17.428 2.75 17.4638 2.75 17.5V20.5C2.75 21.1904 3.30964 21.75 4 21.75C4.69036 21.75 5.25 21.1904 5.25 20.5V19.4352C5.79467 19.6387 6.38434 19.75 7 19.75H17C17.6157 19.75 18.2053 19.6387 18.75 19.4352V20.5C18.75 21.1904 19.3096 21.75 20 21.75C20.6904 21.75 21.25 21.1904 21.25 20.5V17.5C21.25 17.4638 21.2485 17.428 21.2454 17.3925C21.7237 16.6258 22 15.7202 22 14.75C22 12.7803 20.8611 11.0767 19.2059 10.2616L19.1786 10H20.75C21.4404 10 22 9.44036 22 8.75C22 8.05964 21.4404 7.5 20.75 7.5H18.9179L18.898 7.30924C18.6723 5.14441 16.8475 3.5 14.6709 3.5H9.58172C7.52208 3.5 5.75887 4.97684 5.39761 7.00455ZM9.58172 6C8.73363 6 8.0076 6.60811 7.85885 7.44305L7.44784 9.75H16.639L16.4115 7.56851C16.3185 6.67711 15.5672 6 14.6709 6H9.58172ZM17 12.25H7C5.61929 12.25 4.5 13.3693 4.5 14.75C4.5 16.1307 5.61929 17.25 7 17.25H17C18.3807 17.25 19.5 16.1307 19.5 14.75C19.5 13.3693 18.3807 12.25 17 12.25Z\" fill=\"currentColor\"/>"
});
export default Icon;